interface LiveAgentAssistanceIconAbstractProps {
    size?: number;
    className?: string;
  }
  
  export default function LiveAgentAssistanceIconAbstract({ 
    size = 128, 
    className = "" 
  }: LiveAgentAssistanceIconAbstractProps) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        {/* Left side - Live conversation (smaller, background) */}
        <g opacity="0.7">
          {/* Customer bubble 1 */}
          <path
            d="M 4 10 C 4 9 4 8 5 8 L 12 8 C 13 8 13 9 13 10 L 13 16 C 13 17 13 18 12 18 L 7 18 L 5 20 L 5 18 C 4 18 4 17 4 16 Z"
            stroke="currentColor"
            strokeWidth="1.2"
            fill="none"
            strokeLinejoin="round"
          />
          <circle cx="7" cy="12" r="1" fill="currentColor" />
          <rect x="5.5" y="14" width="5" height="1.2" rx="0.6" fill="currentColor" opacity="0.6" />
          
          {/* Agent bubble 1 */}
          <path
            d="M 4 22 C 4 21 4 20 5 20 L 12 20 C 13 20 13 21 13 22 L 13 28 C 13 29 13 30 12 30 L 7 30 L 5 32 L 5 30 C 4 30 4 29 4 28 Z"
            stroke="currentColor"
            strokeWidth="1.2"
            fill="none"
            strokeLinejoin="round"
          />
          <circle cx="7" cy="24" r="1" fill="currentColor" opacity="0.6" />
          <circle cx="9.5" cy="24" r="1" fill="currentColor" />
          <rect x="5.5" y="26" width="5" height="1.2" rx="0.6" fill="currentColor" />
          
          {/* Customer bubble 2 */}
          <path
            d="M 4 34 C 4 33 4 32 5 32 L 12 32 C 13 32 13 33 13 34 L 13 40 C 13 41 13 42 12 42 L 7 42 L 5 44 L 5 42 C 4 42 4 41 4 40 Z"
            stroke="currentColor"
            strokeWidth="1.2"
            fill="none"
            strokeLinejoin="round"
          />
          <circle cx="7" cy="36" r="1" fill="currentColor" />
          <rect x="5.5" y="38" width="5" height="1.2" rx="0.6" fill="currentColor" opacity="0.6" />
          
          {/* Live indicator */}
          <circle cx="8.5" cy="50" r="2" fill="currentColor" opacity="0.4" />
          <circle cx="8.5" cy="50" r="1.5" fill="currentColor" />
        </g>
        
        {/* Center - Live assistance screen (larger, foreground) */}
        <g>
          <rect
            x="18"
            y="8"
            width="44"
            height="55"
            rx="3"
            stroke="currentColor"
            strokeWidth="2.5"
            fill="currentColor"
            fillOpacity="0.05"
          />
          
          {/* Steps - abstract bars with checks/crosses */}
          <g>
            {/* Step 1 - completed (abstract bar) */}
            <path d="M 21 18 L 22.5 19.5 L 25 16" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="27" y="17.5" width="16" height="2.5" rx="1.25" fill="currentColor" opacity="0.7" />
          </g>
          
          <g>
            {/* Step 2 - completed (abstract bar) */}
            <path d="M 21 26 L 22.5 27.5 L 25 24" stroke="currentColor" strokeWidth="1.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
            <rect x="27" y="25.5" width="20" height="2.5" rx="1.25" fill="currentColor" opacity="0.7" />
          </g>
          
          {/* Step missed - abstract bar with X and strikethrough */}
          <g>
            <path d="M 21 32.5 L 24.5 36 M 24.5 32.5 L 21 36" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
            <rect x="27" y="33.5" width="22" height="2.5" rx="1.25" fill="currentColor" opacity="0.3" />
            <line x1="27" y1="34.75" x2="49" y2="34.75" stroke="currentColor" strokeWidth="1.2" opacity="0.4" />
          </g>
          
          {/* Stardust/Sparkle icon for AI - bigger and bolder */}
          <g opacity="1">
            {/* Main star - larger */}
            <path d="M 23 45 L 24.2 42.5 L 26.7 41.5 L 24.2 40.5 L 23 38 L 21.8 40.5 L 19.3 41.5 L 21.8 42.5 Z" fill="currentColor" />
            
            {/* Small star 1 */}
            <path d="M 28 42 L 28.7 40.8 L 30 40.5 L 28.7 40.2 L 28 39 L 27.3 40.2 L 26 40.5 L 27.3 40.8 Z" fill="currentColor" opacity="0.75" />
            
            {/* Small star 2 */}
            <path d="M 25 46 L 25.7 44.8 L 27 44.5 L 25.7 44.2 L 25 43 L 24.3 44.2 L 23 44.5 L 24.3 44.8 Z" fill="currentColor" opacity="0.65" />
          </g>
          
          {/* Suggestion bubble 1 */}
          <g>
            <path
              d="M 22 48 C 22 47 22 47 23 47 L 32 47 C 33 47 33 47 33 48 L 33 53 C 33 54 33 54 32 54 L 26 54 L 28 56 L 26 54 C 22 54 22 54 22 53 Z"
              stroke="currentColor"
              strokeWidth="1"
              fill="none"
              strokeLinejoin="round"
            />
            <circle cx="24.5" cy="49.5" r="0.8" fill="currentColor" opacity="0.6" />
            <rect x="23.5" y="51" width="7" height="1.2" rx="0.6" fill="currentColor" opacity="0.6" />
          </g>
          
          {/* Suggestion bubble 2 */}
          <g>
            <path
              d="M 35 48 C 35 47 35 47 36 47 L 47 47 C 48 47 48 47 48 48 L 48 53 C 48 54 48 54 47 54 L 40 54 L 42 56 L 40 54 C 35 54 35 54 35 53 Z"
              stroke="currentColor"
              strokeWidth="1"
              fill="none"
              strokeLinejoin="round"
            />
            <circle cx="37.5" cy="49.5" r="0.8" fill="currentColor" opacity="0.6" />
            <rect x="36.5" y="51" width="9" height="1.2" rx="0.6" fill="currentColor" opacity="0.6" />
          </g>
          
          {/* Suggestion bubble 3 */}
          <g>
            <path
              d="M 50 48 C 50 47 50 47 51 47 L 57 47 C 58 47 58 47 58 48 L 58 53 C 58 54 58 54 57 54 L 53 54 L 55 56 L 53 54 C 50 54 50 54 50 53 Z"
              stroke="currentColor"
              strokeWidth="1"
              fill="none"
              strokeLinejoin="round"
            />
            <circle cx="52.5" cy="49.5" r="0.8" fill="currentColor" opacity="0.6" />
            <rect x="51.5" y="51" width="4" height="1.2" rx="0.6" fill="currentColor" opacity="0.6" />
          </g>
        </g>
        
        {/* Right side - Call script flowchart (smaller, background) */}
        <g opacity="0.7">
          {/* Flowchart nodes */}
          {/* Start node */}
          <rect x="66" y="12" width="8" height="5" rx="1" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.05" />
          <rect x="67.5" y="14" width="5" height="1" rx="0.5" fill="currentColor" opacity="0.5" />
          
          {/* Flow line */}
          <path d="M 70 17 L 70 22" stroke="currentColor" strokeWidth="1" opacity="0.3" />
          
          {/* Branch node 1 */}
          <circle cx="70" cy="24" r="3" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.1" />
          <circle cx="70" cy="24" r="1" fill="currentColor" />
          
          {/* Branches */}
          <path d="M 70 27 L 66 32" stroke="currentColor" strokeWidth="1" opacity="0.3" />
          <path d="M 70 27 L 70 32" stroke="currentColor" strokeWidth="1" opacity="0.3" />
          <path d="M 70 27 L 74 32" stroke="currentColor" strokeWidth="1" opacity="0.3" />
          
          {/* Branch nodes */}
          <circle cx="66" cy="34" r="2" fill="currentColor" opacity="0.15" />
          <circle cx="70" cy="34" r="2" fill="currentColor" opacity="0.3" />
          <circle cx="74" cy="34" r="2" fill="currentColor" opacity="0.15" />
          
          {/* Continue flow */}
          <path d="M 70 36 L 70 40" stroke="currentColor" strokeWidth="1" opacity="0.3" />
          
          {/* Decision node 2 */}
          <rect x="67" y="40" width="6" height="4" rx="1" stroke="currentColor" strokeWidth="1" fill="currentColor" fillOpacity="0.05" />
          <rect x="68" y="41.5" width="4" height="0.8" rx="0.4" fill="currentColor" opacity="0.5" />
          
          {/* More branches */}
          <path d="M 70 44 L 70 48" stroke="currentColor" strokeWidth="1" opacity="0.3" />
          
          <circle cx="70" cy="50" r="2" fill="currentColor" opacity="0.2" />
        </g>
        
        {/* Connection lines - subtle */}
        <path d="M 14 18 L 18 20" stroke="currentColor" strokeWidth="0.8" strokeDasharray="2 2" opacity="0.15" />
        <path d="M 14 32 L 18 35" stroke="currentColor" strokeWidth="0.8" strokeDasharray="2 2" opacity="0.15" />
        <path d="M 62 20 L 66 18" stroke="currentColor" strokeWidth="0.8" strokeDasharray="2 2" opacity="0.15" />
      </svg>
    );
  }
  